import Api from "./Api";

export default {
  async getAll(obj) {
    const page = obj?.page;
    return Api.get("api/matchingengine", { params: { ...obj } });
  },
};
